import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SendResetPasswordEmail, UserEndpoints } from '@/apis/users/requests.ts'
import {
  REQUEST_STATUS,
  RequestError,
  RequestStatus,
} from '@/common/types_and_interfaces.ts'
import { INITIAL_ERROR } from '@/common/constants.ts'


type ResetPasswordEmailState = {
  status: RequestStatus
  error: RequestError
}

export type ResetPasswordEmailSessionState = {
  request: ResetPasswordEmailState,
  email: string | null; // Added email field
}

const InitialRequestState: ResetPasswordEmailState = {
  status: REQUEST_STATUS.IDLE,
  error: INITIAL_ERROR,
}


const InitialState: ResetPasswordEmailSessionState = {
  request: InitialRequestState, 
  email: null, // Initialize email as null
}

// For Reset Password
type ResetPasswordEmailType = { email: string; }
export const POSTResetPasswordLink = createAsyncThunk(
  UserEndpoints.reset_password_email,
  async function (formData: ResetPasswordEmailType) {
    return await SendResetPasswordEmail(formData.email) // Never rejects
  }
)


export const resetPasswordEmailSlice = createSlice({
  name: 'resetPasswordEmail',
  initialState: InitialState,
  reducers: {    
    setEmail: (state, action: PayloadAction<string>) => {
        state.email = action.payload;
    },
    resetRequestState: (state) => {
        state.request = InitialRequestState; // Reset request to its initial state
    },
  },
  extraReducers: function (builder) {
    builder
      .addCase(POSTResetPasswordLink.pending, function (state) {
        state.request.status = REQUEST_STATUS.IN_FLIGHT
      })            
      .addCase(POSTResetPasswordLink.fulfilled, (state, action) => {
        if (action.payload.data) {
          state.request.status = REQUEST_STATUS.SUCCESS;
          state.request.error = INITIAL_ERROR; // Reset error properties
        } else {
          state.request.error = action.payload.error;
          state.request.status = REQUEST_STATUS.FAILED;
        }
      })      
      .addCase(POSTResetPasswordLink.rejected, (state, action) => {
        state.request.status = REQUEST_STATUS.FAILED;
        state.request.error = action.error as unknown as RequestError; // Handle any errors
      });
  },
})
export const { setEmail,resetRequestState } = resetPasswordEmailSlice.actions;
export default resetPasswordEmailSlice.reducer

